import { render } from "./App.vue?vue&type=template&id=add8331c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=add8331c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__